/**
 * Herdio checkout-path safeguards.
 * Keeps the cart drawer in sync when a third-party cart event omits bundled sections.
 */
function installCartDrawerGuard() {
  const drawer = document.querySelector("cart-drawer");

  if (!drawer || drawer.dataset.herdioCartGuard === "true" || typeof drawer._onCartChangedListener !== "function") {
    return;
  }

  const originalListener = drawer._onCartChangedListener;

  drawer._onCartChangedListener = async (event) => {
    const sectionElement = drawer.closest(".shopify-section");
    const sectionId = sectionElement?.id.replace(/^shopify-section-/, "");
    const sectionHtml = sectionId ? event.detail?.cart?.sections?.[sectionId] : null;

    if (!sectionHtml) {
      await drawer._onCartRefresh();
      return;
    }

    return originalListener(event);
  };

  document.removeEventListener("cart:change", originalListener);
  document.addEventListener("cart:change", drawer._onCartChangedListener);
  drawer.dataset.herdioCartGuard = "true";
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", installCartDrawerGuard, { once: true });
} else {
  installCartDrawerGuard();
}

